var _mask, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNavbarlogo = function SvgNavbarlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.4126,
    cy: 19.5012,
    r: 19.4067,
    fill: "#2862AC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6772 16.552C34.6772 20.3051 31.7099 23.2743 28.1391 23.2743C24.5683 23.2743 21.6011 20.3051 21.6011 16.552C21.6011 12.7988 24.5683 9.82956 28.1391 9.82956C31.7099 9.82956 34.6772 12.7988 34.6772 16.552Z",
    stroke: "#E77CCF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0561 16.552C17.0561 20.3051 14.0889 23.2743 10.518 23.2743C6.94723 23.2743 3.97998 20.3051 3.97998 16.552C3.97998 12.7988 6.94723 9.82956 10.518 9.82956C14.0889 9.82956 17.0561 12.7988 17.0561 16.552Z",
    stroke: "#2F80ED",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0073 32.8939C15.6648 27.9687 21.6357 24.5361 28.5754 24.5361C35.7392 24.5361 41.8705 28.1939 44.3904 33.3755",
    stroke: "#E77CCF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.61377 32.8939C-1.95626 27.9687 4.01456 24.5361 10.9543 24.5361C18.1181 24.5361 24.2494 28.1939 26.7693 33.3755",
    stroke: "#2F80ED",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3906 16.552C25.3906 20.3051 22.4233 23.2743 18.8525 23.2743C15.2817 23.2743 12.3145 20.3051 12.3145 16.552C12.3145 12.7988 15.2817 9.82956 18.8525 9.82956C22.4233 9.82956 25.3906 12.7988 25.3906 16.552Z",
    fill: "white",
    stroke: "#BB6BD9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2777 47.7283L2.79261 34.824C4.08071 33.1095 6.08051 31.2825 8.57108 29.7675C11.7353 27.8428 15.5063 26.5361 19.289 26.5361C23.0884 26.5361 26.8059 27.7892 29.8804 29.669C32.3412 31.1735 34.2839 33.0134 35.5058 34.7898L19.2777 47.7283Z",
    fill: "white",
    stroke: "#BB6BD9",
    strokeWidth: 4
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavbarlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navbarlogo.cbb2ece8.svg";
export { ForwardRef as ReactComponent };